import { ChangeEvent, JSX, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";

import { textFieldCellStyle } from "style/table/TableStyles";
import CreateTextField from "utils/edit/CreateTextField";

import { Widget, WidgetKind, WidgetKindType } from "./DashboardTypes";

export type NewWidgetProps = {
	onCreate: (widget: Widget) => void;
};

let lastUsedType: WidgetKindType | undefined;
const defaultType: WidgetKindType = WidgetKind.EVALUATION_SCORES;

export default function NewWidgetRow(
	props: Readonly<NewWidgetProps>
): JSX.Element {
	const { t } = useTranslation();
	const [type, setType] = useState(lastUsedType ?? defaultType);

	const onCreateCriterion = useCallback(
		(name: string): void => {
			if (name === "") {
				return;
			}

			props.onCreate(Widget.ofType(type, name));
		},
		[props.onCreate, type]
	);

	const handleSelectType = useCallback(
		(event: ChangeEvent<HTMLInputElement>): void => {
			const kind = event.target.value;
			const newType =
				Object.values(WidgetKind).find(key => key === kind) ??
				defaultType;
			setType(newType);
		},
		[]
	);

	return (
		<TableRow>
			<TableCell />
			<TableCell />
			<TableCell
				sx={{
					...textFieldCellStyle(true, true),
					width: "20ch"
				}}>
				<TextField
					select
					variant="standard"
					fullWidth
					value={type}
					onChange={handleSelectType}>
					{Object.values(WidgetKind).map(kind => {
						return (
							<MenuItem key={kind} value={kind}>
								{t(kind)}
							</MenuItem>
						);
					})}
				</TextField>
			</TableCell>
			<TableCell sx={textFieldCellStyle(true, true)}>
				<CreateTextField
					id="name-field"
					variant="standard"
					fullWidth
					onCreate={onCreateCriterion}
				/>
			</TableCell>
		</TableRow>
	);
}
